import PreorderCard from './PreorderCard';

export default PreorderCard;
